import { template } from 'lodash';
import axios from './client';

const SEARCH = '/banner';
const CREATE = '/banner';
const READ = template('/banner/<%= id %>');
const UPDATE = template('/banner/<%= id %>');
const DELETE = template('/banner/<%= id %>');
const GET_SIZES = '/banner/sizes';
const UPLOAD_IMAGES = template('/banner/<%= id %>/images/upload');
const VALIDATE_IMAGE = '/banner/image/validate';

export function search(payload = {}) {
  return axios.get(SEARCH, { params: payload });
}

export function create(payload = {}) {
  return axios.post(CREATE, payload);
}

export function read(id) {
  return axios.get(READ({ id }));
}

export function update(id, payload = {}) {
  return axios.post(UPDATE({ id }), payload);
}

export function remove(id) {
  return axios.delete(DELETE({ id }));
}

export function getSizes(userId) {
  return axios.get(GET_SIZES, { params: { userId }, timeout: 0 });
}

export function uploadImages(id, payload) {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(UPLOAD_IMAGES({ id }), payload, { headers });
}

export function validateImage(payload) {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(VALIDATE_IMAGE, payload, { headers });
}
